//import { TimeScale } from 'chart.js';
import React, { Component } from 'react';
import './InputSelect.css'

export class InputSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: "",
            selectedName: "請選擇",
            isSelecting: false
        }
        this.ref = React.createRef();
    }

    handler(event) {
        if (this.state.isSelecting && this.ref.current && !this.ref.current.contains(event.target)) {
            this.setState({ isSelecting: false })
        }
    };
    componentDidMount() {
        document.addEventListener("mousedown", this.handler.bind(this));
        document.addEventListener("touchstart", this.handler.bind(this));
        if (!!this.props.DefaultValue) {
            this.setState({ selected: this.props.DefaultValue })
        }
    }

    componentWillMount() {
        document.removeEventListener("mousedown", this.handler.bind(this));
        document.removeEventListener("touchstart", this.handler.bind(this));
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.Options !== this.props.Options) {
            let defaultValue = "";
            if (!!this.props.DefaultValue) {
                defaultValue = this.props.DefaultValue;
            }
            let e = { target: { value: defaultValue } }
            if (!this.props.defaultNoTrigger)
                this.props.OnChange(e);
            this.setState({ selectedName: this.props.DefaultValue !== undefined ? this.props.DefaultValue : "請選擇", });
        }
    }

    render() {
        return (
            <div className='InputSelect'
                ref={this.ref}
                style={this.props.Style}
            >
                <div className='InputSelect__select'
                    style={{
                        borderRadius: this.state.isSelecting ? "10px 10px 0 0" : "10px",
                        borderBottom: this.state.isSelecting ? "solid 1px black" : "",
                    }}
                    onClick={() => { this.setState({ isSelecting: !this.state.isSelecting }) }}
                >
                    <span>{this.props.value ?? this.state.selectedName}</span>
                    <div className="InputSelect__triangle" />
                </div>
                <div className='InputSelect__option' style={{ display: this.state.isSelecting ? "" : "none" }}>
                    {
                        this.props.Options.map((ele, index) => {
                            let value = ele;
                            let name = ele;
                            if (typeof ele !== "string") {
                                value = ele.value;
                                name = ele.name;
                            }
                            return (
                                <div key={index}
                                    style={{
                                        backgroundColor: this.state.selected === value ? "rgb(90 208 195)" : "",
                                        color: this.state.selected === value ? "#FFF" : ""
                                    }}
                                    onClick={() => {
                                        this.setState({ isSelecting: false, selected: value, selectedName: name })
                                        let e = { target: { value: value ,name: name} }
                                        this.props.OnChange(e)
                                    }}>
                                    {name}
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
}
